export default __webpack_public_path__ + "static/media/mobily-sample.6d1d8585.svg";